module.exports = __webpack_public_path__ + "static/media/logo-small.6ef69866.png";